/**
 * Product Validation Schema
 */

import { z } from "zod";

export const productSchema = z.object({
  // Dados principais
  name: z.string()
    .trim()
    .min(3, "Nome deve ter no mínimo 3 caracteres")
    .max(200, "Nome muito longo"),
  
  category: z.string()
    .min(1, "Categoria é obrigatória"),
  
  // Unidade Padrão (obrigatório)
  unidadePadrao: z.enum(['peso_g', 'volume_ml', 'unidade'], {
    required_error: "Unidade Padrão é obrigatória",
    invalid_type_error: "Unidade Padrão inválida"
  }),
  
  // Configurações de controle
  perishable: z.boolean().default(false),
  
  controlLot: z.boolean().default(false),
  
  controlExpiry: z.boolean().default(false),
  
  // Quantidade mínima
  minQuantity: z.number()
    .min(0, "Quantidade mínima não pode ser negativa")
    .max(999999, "Valor máximo excedido")
    .optional()
    .nullable()
    .default(0),
  
  // Observações
  notes: z.string()
    .max(500, "Observações devem ter no máximo 500 caracteres")
    .optional()
    .nullable(),
})
.refine(
  (data) => {
    // Se perecível, deve controlar lote e validade
    if (data.perishable) {
      return data.controlLot === true && data.controlExpiry === true;
    }
    return true;
  },
  {
    message: "Produtos perecíveis devem controlar lote e validade",
    path: ["perishable"],
  }
);

export type ProductFormData = z.infer<typeof productSchema>;
